import { render, staticRenderFns } from "./activation-address.vue?vue&type=template&id=46a2e292&"
import script from "./activation-address.vue?vue&type=script&lang=js&"
export * from "./activation-address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports